import React, { useEffect, useState } from 'react';
import './index.css';
import StagePagination from './components/StagePagination';
//import { ReactComponent as ReturnIcon } from 'common/icons/return.svg';
import ClientResponseProps from 'common/types/UserResponseProps';
import FindClientPage from './pages/FindClientPage';
import AddUserPage from 'pages/AddUserPage';
import OrderProductPage from './pages/OrderProductPage';
import { exampleClientResponse } from 'common/types/UserResponseProps';
import OrderProductSettings, { FullItem } from './pages/OrderProductSettings';
import CartPage from './pages/CartPage';
import sendFetch from 'common/utils/fetch';
import OrderCompletionPage from './pages/OrderCompletionPage';
import { CompletionDataProps } from './types/CompletionDataProps';
import { useNavigate } from 'react-router-dom';
import { Modal } from '@mui/material';
import styled from '@emotion/styled';
import Button from 'common/components/Button';
import { ReactComponent as PlusIcon } from 'common/icons/plus.svg';
import { ReactComponent as ImportIcon } from 'common/icons/import.svg';
import { ReactComponent as PrinterIcon } from 'common/icons/printer.svg';
import { ReactComponent as ReturnIcon } from 'common/icons/return.svg';
import EditClientPage from './pages/EditClientPage';
import OrderInfoPage from './pages/OrderInfoPage';

const ModalContainer = styled.div`
  width: 623px;
  padding: 24px;
  flex-shrink: 0;
  border-radius: 14px;
  border: 1px solid #9B9EAB;
  background-color: ${(props) => props.theme.colors.secondaryColor};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display:flex;
  flex-direction: column;
  gap: 48px;
  align-items: center;
`;

export const MoreButton = styled.button`
  background: ${(props) => props.theme.colors.secondaryColor};
    color: ${(props) => props.theme.colors.primaryTextColor};
    border: 1px solid ${(props) => props.theme.colors.gray};
    padding: 10px 18px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    font-family: Mulish;
    font-size: 16px;
    font-style: normal;
    cursor: pointer;
    font-weight: 300;
    gap: 8px;
    line-height: 100%;
    letter-spacing: 1px;
    transition: 0.5s;
    &:hover {
        background: ${(props) => props.theme.colors.secondaryHoverColor};
        color: ${(props) => props.theme.colors.primaryTextColor};
        border: 1px solid ${(props) => props.theme.colors.primaryColor};
    }
`;
export const MoreButtonDropdown = styled.div`
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.colors.gray};
  background-color: ${(props) => props.theme.colors.secondaryColor};
  position: absolute;
  top: 58px;
  left: 0;
`;

export default function CreateOrderPage() {
  const [client, setClient] = useState(null as ClientResponseProps);
  const [firm, setFirm] = useState(null as string);
  const [pageType, setPageType] = useState('order' as string);
  const [priceList, setPriceList] = useState(null as string);
  const [firmName, setFirmName] = useState(null as string);
  const [priceListName, setPriceListName] = useState(null as string);
  const [orderId, setOrderId] = useState(null as string | number);
  const [selectedItem, setSelectedItem] = useState(null as FullItem);
  const [itemList, setItemList] = useState([] as FullItem[]);
  const setBlanks = false;
  const navigate = useNavigate();
  const [isChangeable, setIsChangeable] = useState(true);
  const [stage, setStage] = useState(1);
  const [maxStage, setMaxStage] = useState(1);
  const [showModal, setShowModal] = useState({
    completion: false,
    error: false,
    clear: false,
  });
  const [modalMore, setModalMore] = useState(false);
  const [completionData, setCompletionData] = useState({
    agreements: [],
    isPartner: false,
    locationId: null,
    client: {
      lastName: '',
      firstName: '',
      patronymic: '',
      phoneNumber: '',
    },
    paymentType: null,
    promocodeType: null,
    promocode: [],
    useBonuses: false,
    totalPrice: 0,
    isOther: false,
  } as CompletionDataProps);

  useEffect(() => {
    // set blank states so it works without api
    if (setBlanks) {
      setClient(exampleClientResponse);
      setFirm('1');
      setPriceList('1');
      setOrderId('1');
      setStage(3);
      setMaxStage(3);
    }
  }, [setBlanks]);


  // useEffect(() => {
  //   if (client && firm && priceList && orderId) {
  //     setMaxStage(2);
  //   }
  // }, [stage]);





  const finishOrder = async () => {
    const finalData = {
      orderId: orderId,
      paymentType: completionData.paymentType,
      pickUpDepartmentId: completionData.locationId,
      comment: completionData.comment,
      departmentId: firm,
      issueDate: completionData.issueDate?.toISOString(),
      totalPrice: completionData.totalPrice,
      isOther: completionData.isOther,
      firstName: completionData.client.firstName,
      lastName: completionData.client.lastName,
      patronymic: completionData.client.patronymic,
      phoneNumber: completionData.client.phoneNumber,
      isPartner: completionData.isPartner,
      priceList: priceList,
      isGetInfoAboutReady: completionData.agreements.includes(1),
      isGetReceiptOnEmail: completionData.agreements.includes(2),
      isGetInfoOnEmail: completionData.agreements.includes(3),
    };
    // Convert to formData

    const formData = new FormData();
    Object.keys(finalData).forEach((key) => {
      formData.append(key, finalData[key]?.toString() || '');
    });



    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const response: any = await sendFetch('https://api-workspace.astin.net/api/order/accept-order',
      {
        method: 'POST',
        data: formData,
      },
    );
    console.log(response);
    if (response[0] === 200 && response[1].statusCode === 200) {
      setShowModal({
        completion: true,
        error: false,
        clear: false,
      });
    }
  };

  const addItem = async (item: FullItem) => {
    if (item.type === 'service') {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const response: any = await sendFetch('https://api-workspace.astin.net/api/order/create-service-item',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          data: {
            orderId: orderId,
            departmentId: firm,
            serviceId: item.id,
            clothesGender: item.clothesGender,
            marking: item.marking,
            comment: item.comment,
            stickingLabel: item.stickingLabel,
            count: item.count,
            acDecorId: item.acDecorId,
            adServiceId: item.adServiceId,
            adConditionsId: item.adConditionsId,
            brandsId: item.brandsId,
            colorsId: item.colorsId,
            defectsId: item.defectsId,
            originStainsId: item.originStainsId,
            processingTypesId: item.processingTypesId,
            spotsLocationId: item.spotsLocationId,
          },
        },
      );
      console.log(response);
      if (response[0] === 200 && response[1].statusCode === 200) {
        setItemList([...itemList, { ...item, id: response[1].id }]);
        setSelectedItem(null);
        setStage(2);
        setMaxStage(3);
        setPageType('order');
      }

    } else if (item.type === 'product') {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const response: any = await sendFetch('https://api-workspace.astin.net/api/order/create-product-item',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          data: {
            orderId: orderId || null,
            productId: item.id || null,
            count: item.count || 1,
            price: item.price || 0,
            description: item.description || '',
            productColorsId: item.productColorsId || null,
            productMaterialId: item.productMaterialId || null,
            productCoatingId: item.productCoatingId || null,
            productFormId: item.productFormId || null,
            productSizeId: item.productSizeId || '',
          },
        },
      );
      console.log(response);
      if (response[0] === 200 && response[1].statusCode === 200) {
        setItemList([...itemList, { ...item, id: response[1].id }]);
        setSelectedItem(null);
        setStage(2);
        setMaxStage(3);
        setPageType('order');
      }
    }
  };
  const changeCount = async (id: number | string, type: 'increase' | 'decrease') => {
    const formData = new FormData();
    formData.append('id', id?.toString());
    const link = type === 'increase' ? 'https://api-workspace.astin.net/api/order/items/increment-item' : 'https://api-workspace.astin.net/api/order/items/decrement-item';
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const response: any = await sendFetch(link,
      {
        method: 'PATCH',
        data: formData,
      },
    );
    console.log(response);
    if (response[0] === 200 && response[1].statusCode === 200) {
      setItemList(itemList.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            count: response[1].count,
            isMaxCount: response[1].isMax,
          };
        } else {
          return item;
        }
      }));
    } else if (response[0] === 304 && type === 'increase') {
      // max count
      setItemList(itemList.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            isMaxCount: true,
          };
        } else {
          return item;
        }
      }));
    }
  };
  const editItem = (item: FullItem) => {
    console.log(item);
    /*setSelectedItem(item);
    setStage(2);
    setPageType('order');*/
  };
  const deleteItem = async (id: number | string) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const response: any = await sendFetch('https://api-workspace.astin.net/api/order/items/delete-item',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        data: {
          orderId: orderId,
          serviceId: id,
        },
      },
    );
    if (response[0] === 200 && response[1].statusCode === 200) {
      setItemList(itemList.filter((item) => item.id !== id));
    }
  };

  const closeModal = () => {
    setShowModal({
      completion: false,
      error: false,
      clear: false,
    });
    setModalMore(false);
    //navigate('/services');
  };

  const closeCompletionModal = () => {
    setShowModal({
      completion: false,
      error: false,
      clear: false,
    });
    setModalMore(false);
    navigate('/services');
  };

  const closeModalMore = (e: MouseEvent) => {
    if (!(e.target as HTMLElement).closest('.order-more-button-container')) {
      setModalMore(false);
    }
  };

  // close modalMore on click outside
  useEffect(() => {
    if (modalMore) {
      document.addEventListener('click', closeModalMore);
    }
    return () => {
      document.removeEventListener('click', closeModalMore);
    };
  }, [modalMore]);

  const openClearItems = () => {
    setShowModal({
      completion: false,
      error: false,
      clear: true,
    });
  };

  const clearItems = async () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const response: any = await sendFetch('https://api-workspace.astin.net/api/order/delete-order',
      {
        method: 'DELETE',
        params: {
          orderId: orderId,
        },
      },
    );
    if (response[0] === 200 && response[1].statusCode === 200) {
      setItemList([]);
      setStage(1);
      setPageType('order');
      setMaxStage(1);
      setIsChangeable(true);
      setCompletionData({
        agreements: [],
        isPartner: false,
        locationId: null,
        client: {
          lastName: '',
          firstName: '',
          patronymic: '',
          phoneNumber: '',
        },
        paymentType: null,
        promocodeType: null,
        promocode: [],
        useBonuses: false,
        totalPrice: 0,
        isOther: false,
      });
      setSelectedItem(null);
      setOrderId(null);
      closeModal();
    } else {
      setShowModal({
        completion: false,
        error: true,
        clear: false,
      });
    }
  };

  if (pageType === 'create-client') {
    return <AddUserPage order setPageType={setPageType} setClient={setClient} />;
  }
  if (pageType === 'edit-client') {
    return (
      <section className='user-section'>
        <h2 className='new-h2 add-user-title'>Картка клієнта</h2>
        <EditClientPage client={client} id={client.id} setClient={setClient} setPageType={setPageType} type={client?.companyNumber?.length > 0 || false} />
      </section>
    );
  }

  return (
    <section className='order-section'>
      <Modal open={showModal.error} onClose={closeModal} >
        <ModalContainer>
          <div className='order-modal-text-wrapper'>
            <span className='big-text error-text'>
              Сталася технічна помилка
            </span>
            <p>
              Бажаєте зберегти замовлення у чернетку?
            </p>
          </div>
          <div className='order-modal-buttons-wrapper'>
            <Button fontSize='16px' label='Повернутись' onClick={() => { navigate('/services'); }} />
            <Button fontSize='16px' primary label='Так, зберегти' onClick={() => { navigate('/services'); }} />
          </div>
        </ModalContainer>
      </Modal>
      <Modal open={showModal.completion} onClose={closeCompletionModal} >
        <ModalContainer>
          <div className='order-modal-text-wrapper'>
            <span className='big-text'>
              Замовлення оформлено успішно
            </span>
          </div>
          <div className='order-modal-buttons-wrapper'>
            <div className='order-more-button-container'>
              <MoreButton onClick={() => { setModalMore(true); }}>
                <PlusIcon className='svg-black' />
                <span>Зберегти як</span>
              </MoreButton>
              {modalMore &&
                <MoreButtonDropdown onClick={(e) => { e.stopPropagation(); }}>
                  <div className='order-more-button-line'>
                    <PlusIcon height={16} width={16} className='svg-black' />
                    <span className='order-more-button-text'>Додати до замовлення</span>
                  </div>
                  <div className='order-more-button-line'>
                    <ImportIcon height={16} width={16} className='svg-black' />
                    <span className='order-more-button-text'>Завантажити квитанцію</span>
                  </div>
                  <div className='order-more-button-line'>
                    <PrinterIcon height={16} width={16} className='svg-black' />
                    <span className='order-more-button-text'>Роздрукувати</span>
                  </div>
                  <div className='order-more-button-line'>
                    <ReturnIcon
                      height={16}
                      width={16}
                      className='svg-black svg-fill'
                      style={{ transform: 'scaleX(-1)' }}
                    />
                    <span className='order-more-button-text'>Відправити</span>
                  </div>
                </MoreButtonDropdown>
              }
            </div>
            <Button fontSize='16px' primary label='Завершити' onClick={closeCompletionModal} />
          </div>
        </ModalContainer>
      </Modal>
      <Modal open={showModal.clear} onClose={closeModal}>
        <ModalContainer>
          <div className='order-modal-text-wrapper'>
            <span className='big-text error-text'>
              Очистити замовлення?
            </span>
            <p>
              Ви впевнені, що хочете очистити замовлення?
            </p>
          </div>
          <div className='order-modal-buttons-wrapper'>
            <Button fontSize='16px' label='Повернутись' onClick={() => { closeModal(); }} />
            <Button fontSize='16px' primary label='Так, очистити' onClick={() => { clearItems(); }} />
          </div>
        </ModalContainer>
      </Modal>
      <div className='order-header'>
        <h2 className='new-h2'>Створення замовлення</h2>
        <StagePagination setPageType={setPageType} stageCount={3} stage={stage} maxStage={maxStage} setStage={setStage} />
      </div>
      {pageType === 'cart' && <CartPage changeCount={changeCount} setMaxStage={setMaxStage} deleteItem={deleteItem} editItem={editItem} setPageType={setPageType} client={client} setStage={setStage} itemList={itemList} setItemList={setItemList} />}
      {stage === 1 && pageType === 'order' &&
        <FindClientPage setFirmName={setFirmName} setPriceListName={setPriceListName} setIsChangeable={setIsChangeable} clearItems={openClearItems} isChangeable={isChangeable} setOrderId={setOrderId} setPageType={setPageType} setStage={setStage} setMaxStage={setMaxStage} firm={firm} setFirm={setFirm} client={client} setClient={setClient} priceList={priceList} setPriceList={setPriceList} />
      }
      {stage === 2 && pageType === 'order' && orderId && !selectedItem ?
        <OrderProductPage itemCount={itemList.length} orderId={orderId} setStage={setStage} client={client} firm={firm} priceList={priceList} selectedItem={selectedItem} setSelectedItem={setSelectedItem} setPageType={setPageType} /> : stage === 2 && selectedItem && orderId && pageType === 'order' &&
        <OrderProductSettings itemCount={itemList.length} addItem={addItem} orderId={orderId} setStage={setStage} client={client} firm={firm} priceList={priceList} selectedItem={selectedItem} setSelectedItem={setSelectedItem} setPageType={setPageType} />
      }
      {
        stage === 3 && pageType === 'order' &&
        <OrderCompletionPage finishOrder={finishOrder} completionData={completionData} setCompletionData={setCompletionData} orderId={orderId} setStage={setStage} client={client} firm={firm} priceList={priceList} itemList={itemList} setPageType={setPageType} />
      }
      {
        stage === 3 && pageType === 'info' &&
        <OrderInfoPage priceListName={priceListName} firmName={firmName} finishOrder={finishOrder} completionData={completionData} orderId={orderId} setStage={setStage} setPageType={setPageType} priceList={priceList} itemList={itemList} firm={firm} client={client} />
      }
    </section>
  );
}